"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.deptAdd = deptAdd;
exports.deptGet = deptGet;
exports.edit = edit;
exports.get = get;
exports.updateByDept = updateByDept;
exports.updateByUser = updateByUser;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/userLists',
    method: 'post',
    data: data
  });
}

function deptAdd(data) {
  return (0, _request.default)({
    url: 'api/userLists/deptCreate',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/userLists/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/userLists',
    method: 'put',
    data: data
  });
}

function updateByDept(data) {
  return (0, _request.default)({
    url: 'api/userLists/updateByDept',
    method: 'put',
    data: data
  });
}

function updateByUser(data) {
  return (0, _request.default)({
    url: 'api/userLists/updateByUser',
    method: 'put',
    data: data
  });
}

function get(data) {
  return (0, _request.default)({
    url: 'api/userLists/get',
    method: 'get',
    data: data
  });
}

function deptGet(data) {
  return (0, _request.default)({
    url: 'api/userLists/deptGet',
    method: 'get',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  get: get,
  deptAdd: deptAdd,
  deptGet: deptGet,
  updateByDept: updateByDept,
  updateByUser: updateByUser
};
exports.default = _default;